<template>
    <es-loader
        v-if="loading"
        style="margin: 15rem"
    />
    <div v-else>
        <template>
            <div
                v-if="showModal"
                class="modal is-active"
                role="dialog"
                aria-label="Confirm Retire/Merge ID Decision"
                aria-hidden="false"
            >
                <div class="modal-background"></div>
                <div class="modal-card">
                    <header class="modal-card-head">
                        <p class="modal-card-title">
                            <strong>Confirm Decision</strong>
                        </p>
                        <button
                            @click.prevent="toggleModal()"
                            class="icon is-right"
                            ref="closeIcon"
                        >
                            <font-awesome-icon :icon="['fal', 'times']" title="Close" />
                        </button>
                    </header>
                    <section
                        v-if="mergePerson"
                        class="modal-card-body"
                    >
                        <div class="modal-body">
                            Are you sure you want to retire ID and merge records?<br/><br/>
                        </div>
                        <div class="update-box">
                            <button @click.prevent="toggleModal()"
                                class="button button-link has-underline"
                            >
                                Cancel
                            </button>
                            <button
                                @click="retire()"
                                class="button is-primary"
                            >
                                Yes Retire ID and Merge Record
                            </button>
                        </div>
                    </section>
                    <section
                        v-else
                        class="modal-card-body"
                    >
                        <div class="modal-body">
                            Are you sure you want to retire ID with no merge?<br/><br/>
                        </div>
                        <div class="update-box">
                            <button
                                @click.prevent="toggleModal()"
                                style="margin-right: 1rem"
                                class="button button-link has-underline"
                            >
                                Cancel
                            </button>
                            <button
                                @click="retire()"
                                class="button is-primary"
                            >
                                Yes Retire ID with No Merge
                            </button>
                        </div>
                    </section>
                </div>
            </div>
        </template>
        <div class="document">
            <div class="header">
                <es-header>
                    <template #header>
                        <div class="header-title">
                            Review Retire/Merge ID Details
                        </div>
                    </template>
                </es-header>
            </div>
            <div class="no-border-top">
                <div class="no-bottom-border">
                    <div class="columns">
                        <div class="column is-three-quarters">
                            <es-form>
                                <template #es-form>
                                    <div class="row removeUnderline">
                                        <div class="field is-horizontal">
                                            <div class="field-label is-normal">
                                                <label
                                                    class="label"
                                                    id="retireLabel"
                                                >
                                                    ID to Retire
                                                </label>
                                            </div>
                                            <div class="field-body">
                                                <div class="field">
                                                    <div class="control">
                                                        <input
                                                            type="text"
                                                            class="input is-static"
                                                            :value="retirePerson.stateStudentId
                                                                + ' (' + retirePerson.firstName
                                                                + ' ' + retirePerson.lastName + ')'"
                                                            aria-labelledby="retireLabel"
                                                            readonly
                                                            :title="retirePerson.stateStudentId
                                                                + ' (' + retirePerson.firstName
                                                                + ' ' + retirePerson.lastName + ')'"
                                                        >
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div
                                        v-if="mergePerson"
                                        class="row removeUnderline"
                                    >
                                        <div class="field is-horizontal">
                                            <div class="field-label is-normal">
                                                <label
                                                    class="label"
                                                    id="mergeLabel"
                                                >
                                                    ID to Merge to
                                                </label>
                                            </div>
                                            <div class="field-body">
                                                <div class="field">
                                                    <div class="control">
                                                        <input
                                                            type="text"
                                                            class="input is-static"
                                                            :value="mergePerson.stateStudentId
                                                                + ' (' + mergePerson.firstName
                                                                + ' ' + mergePerson.lastName + ')'"
                                                            aria-labelledby="mergeLabel"
                                                            readonly
                                                            :title="mergePerson.stateStudentId
                                                                + ' (' + mergePerson.firstName
                                                                + ' ' + mergePerson.lastName + ')'"
                                                        >
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="row removeUnderline">
                                        <div class="field is-horizontal">
                                            <div class="field-label is-normal">
                                                <label
                                                    class="label"
                                                    id="reasonOfRetirement"
                                                >
                                                    Reason of Retirement
                                                </label>
                                            </div>
                                            <div class="field-body">
                                                <div class="field">
                                                    <div class="control">
                                                        <input
                                                            type="text"
                                                            class="input"
                                                            v-model="reasonToRetire"
                                                            :class="{ 'is-danger': hasErrorReasonToRetire }"
                                                            aria-labelledby="reasonOfRetirement"
                                                            @keyup.prevent="validateReasonToRetire"
                                                        >
                                                    </div>
                                                    <span
                                                        v-if="hasErrorReasonToRetire"
                                                        class="help is-danger"
                                                    >
                                                        {{ msgReasonToRetire }}
                                                    </span>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div
                                        v-if="mergePerson"
                                        class="row removeUnderline"
                                    >
                                        <div class="field is-horizontal">
                                            <div class="field-label is-normal">
                                                <label class="label">
                                                    Merge History Records
                                                </label>
                                            </div>
                                            <div class="field-body">
                                                <div class="field">
                                                    <div class="control">
                                                        <div class="buttons has-addons">
                                                            <button
                                                                v-for="(item, index) in yesNoOptions"
                                                                :key="index"
                                                                class="button button--form"
                                                                @click="mergeHistoryRecords = item.option"
                                                                :class="{ 'is-active': mergeHistoryRecords === item.option }"
                                                                style="min-width: 50px"
                                                            >
                                                                {{ item.label }}
                                                            </button>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </template>
                            </es-form>
                        </div>
                        <div
                            class="column"
                            style="padding: 3rem"
                        >
                            <div class="box-align">
                                <div class="box-num">
                                    <strong>{{ retirePersonHistInfo.totalCount }}</strong>
                                </div>
                            </div>
                            <div class="info">
                                History Records from the "ID to Retire"
                                will be merged into the "ID to Merge To".<br/><br/>
                                The Master Record is always merged to the "ID to Merge To".
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div
                class="is-flex flex-justify--end flex-align--center"
                style="margin: 0 5.15rem; padding: 1rem 0; border-top: 1px solid #dee2e6!important"
            >
                <button
                    class="button button-link has-underline"
                    @click="cancelToList"
                    style="margin-right: 1rem"
                    tabindex="0"
                >
                    Cancel and Return to List
                </button>
                <button
                    class="button button-link has-underline"
                    @click="cancelToDetails"
                    style="margin-right: 1rem"
                    tabindex="0"
                    ref="linkReturnDetails"
                >
                    Cancel and Return to Details
                </button>
                <button
                    v-if="mergePerson"
                    class="button is-primary"
                    @click="toggleModal('btnMerge')"
                    ref="btnMerge"
                >
                    Retire ID and Merge Records
                </button>
                <button
                    v-else
                    class="button is-primary"
                    @click="toggleModal('btnNoMerge')"
                    ref="btnNoMerge"
                >
                    Retire ID with No Merge
                </button>
            </div>
        </div>
    </div>
</template>

<script>
import axios from 'axios';
import EsForm from '@/components/EsForm.vue';
import EsHeader from '@/components/EsHeader.vue';
import EsLoader from '@/components/EsLoader.vue';
import NotificationManager from '@/mixins/NotificationManager';
import AccessibilityUtils from '@/mixins/AccessibilityUtils';

export default {
  mixins: [
    NotificationManager,
    AccessibilityUtils,
  ],
  components: {
    EsForm,
    EsHeader,
    EsLoader,
  },
  props: {
    mergePerson: {
      type: Object,
    },
    retirePersonHistInfo: {
      type: Object,
    },
    retirePerson: {
      type: Object,
    },
  },
  data() {
    return this.initialData();
  },
  created() {
    this.yesNoOptions = [
      {
        label: 'Yes',
        option: true,
      },
      {
        label: 'No',
        option: false,
      },
    ];
  },
  computed: {
    idToMerge() {
      const temp = {}; const
        mergeIdArray = [];
      if (this.mergeId) {
        temp.personId = this.mergeId;
        temp.decision = 'merge';
        mergeIdArray.push(temp);
      }
      return mergeIdArray;
    },
    idToRetire() {
      const temp = {}; const
        retireIdArray = [];
      if (this.retireId) {
        temp.personId = this.retireId;
        temp.decision = 'retire';
        retireIdArray.push(temp);
      }
      return retireIdArray;
    },
    idsForComparePage() {
      return this.idToMerge.length ? this.idToRetire.concat(this.idToMerge) : this.idToRetire;
    },
    payload() {
      const temp = {};
      temp.idToRetire = this.retirePerson.stateStudentId;
      temp.retireReason = this.reasonToRetire;
      if (this.mergePerson) {
        temp.idToMergeTo = this.mergePerson.stateStudentId;
        if (this.mergeHistoryRecords) {
          temp.command = 'RETIRE_AND_MERGE_MOVE_HISTORY';
        } else {
          temp.command = 'RETIRE_AND_MERGE';
        }
      } else {
        temp.command = 'RETIRE_NO_MERGE';
      }
      return temp;
    },
  },
  methods: {
    cancelToDetails() {
      this.hideNotification();
      this.$emit('cancelToDetails');
    },
    cancelToList() {
      this.hideNotification();
      this.$emit('cancelToList');
    },
    initialData() {
      return {
        formErrorMsg: 'There were some errors. Please fix the errors highlighted in the fields below.',
        hasErrorReasonToRetire: false,
        loading: false,
        mergeId: null,
        msgReasonToRetire: null,
        mergeHistoryRecords: true,
        reasonToRetire: null,
        response: null,
        retireId: null,
        showModal: false,
        yesNoOptions: [],
        refName: '',
      };
    },
    async retire() {
      this.toggleModal();
      this.loading = true;
      try {
        this.response = await axios({
          method: 'post',
          url: '/idmanager/retire',
          data: this.payload,
        });
      } catch (err) {
        this.showError(err.response.data.message);
        this.loading = false;
      } finally {
        this.$emit('showRetireConfirmedPage', this.response.data);
      }
    },
    showError(error) {
      this.showNotification('danger', [error]);
    },
    toggleModal(linkName) {
      if (!this.reasonToRetire) {
        this.hasErrorReasonToRetire = true;
        this.msgReasonToRetire = 'Reason of Retirement is required.';
        this.showError(this.formErrorMsg);
      } else if (this.hasErrorReasonToRetire) {
        this.hasErrorReasonToRetire = true;
        this.msgReasonToRetire = 'Reason of Retirement should be no more than 250 characters.';
        this.showError(this.formErrorMsg);
      } else {
        this.showModal = !this.showModal;
        if (this.showModal) {
          if (linkName) {
            this.refName = linkName;
          } else {
            this.refName = 'linkReturnDetails';
          }
          this.$nextTick(() => {
            if (this.$refs.closeIcon) {
              this.$refs.closeIcon.focus();
            }
            this.modalTrapFocus();
          });
          this.$el.addEventListener('keydown', this.modalHandleEscKey);
        } else {
          this.$nextTick(() => {
            if (this.$refs[this.refName]) {
              this.$refs[this.refName].focus();
            }
          });
          this.$el.removeEventListener('keydown', this.modalHandleEscKey);
        }
      }
    },
    validateReasonToRetire() {
      if (!this.reasonToRetire) {
        this.hasErrorReasonToRetire = true;
        this.msgReasonToRetire = 'Reason of Retirement is required.';
        this.showError(this.formErrorMsg);
      } else if (this.reasonToRetire.length > 250) {
        this.hasErrorReasonToRetire = true;
        this.msgReasonToRetire = 'Reason of Retirement should be no more than 250 characters.';
      } else {
        this.hasErrorReasonToRetire = false;
        this.msgReasonToRetire = null;
        this.$store.state.notifications.isActive = false;
        this.$store.state.notifications.notificationType = null;
      }
    },
  },
};
</script>

<style lang="sass" scoped>
.box-align
    padding: 1rem
    text-align: -webkit-center;
.box-num
    color: #fff
    background: #a5a5a5
    font-size: 1.75rem
    width: 50px
    height: 50px
    line-height: 50px
    text-align: center
.button-link
    font-size: 12px
.info
    font-size: 12px
.is-three-quarters
    border-right: 1px solid #dee2e6!important
    margin: 1rem 0
.modal-body
    margin-bottom: 1rem
    display: flex
    justify-content: flex-start
.modal-card-body
    border-bottom-right-radius: .4rem
    border-bottom-left-radius: .4rem
    text-align: right
.modal-card-head
    background-color: #F5F5F5
    text-align: left
.modal-card-title
    margin-bottom: 0 !important
    color: #444
.update-box
    display: flex
    align-items: center
    justify-content: flex-end
    button
      margin-left: 1rem
.control input
  text-overflow: ellipsis
</style>
